
























import { IGroupTypeEntitySideCard } from "@/lib/utility/group/interface/group-type-entity-side-card.interface";
import { handleError } from "@/lib/utility/handleError";
import { IContract } from "@/models/contract.entity";
import Vue from "vue";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import LatestEntriesCardEmpty from "../cards/LatestEntriesCardEmpty.vue";
import SideCard from "../utility/SideCard.vue";
import ContractDetail from "./ContractDetail.vue";

@Component({
  components: { SideCard, ContractDetail, LatestEntriesCardEmpty }
})
export default class ContractSideCard extends mixins(Vue) implements IGroupTypeEntitySideCard {
  @Prop()
  value!: IContract;

  get fullscreenBreakpoint() {
    return this.$vuetify.breakpoint.width < 1500;
  }

  isLoading = false;

  async mounted() {
    try {
      this.isLoading = true;

      await this.value.fetch();
    } catch (error) {
      handleError(error);
      this.close();
    } finally {
      this.isLoading = false;
    }
  }

  close() {
    this.$emit("close");
  }
}
